import React from 'react';
import {AnimatePresence, motion, tokens} from '@sail/motion';
import {view} from '@sail/ui';

import {ReturnAddressScreen} from 'src/return/screens/ReturnAddressScreen';
import {ReturnCompleteScreen} from 'src/return/screens/ReturnCompleteScreen';
import {
  type ReturnDetailsCollectionState,
  useSelector,
} from 'src/return/state/store';
import {absurd} from 'src/utils/absurd';
import {MEDIA_QUERIES} from 'src/v2/util/mediaQueries';

const ScreenComponent = ({
  screen,
}: {
  screen: ReturnDetailsCollectionState['state'];
}): React.ReactElement => {
  switch (screen) {
    case 'created':
      return <ReturnAddressScreen />;
    case 'completed':
      return <ReturnCompleteScreen />;
    default:
      return absurd(screen);
  }
};

export const ScreenManager = (): React.ReactElement => {
  const screen = useSelector((state) => state.state);

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        paddingTop: 'space.500',
        [MEDIA_QUERIES.mediumWidth]: {
          paddingTop: '0',
        },
      }}
      data-testid="return-screen-manager"
    >
      <AnimatePresence mode="wait">
        <view.div
          key={screen}
          uses={[
            motion({
              initial: {opacity: 0, x: tokens.translate.regular},
              animate: {opacity: 1, x: 0},
              exit: {opacity: 0, x: -tokens.translate.regular},
              transition: tokens.transition.default,
            }),
          ]}
          css={{stack: 'y', gapY: 'large', height: 'fit'}}
        >
          <ScreenComponent screen={screen} />
        </view.div>
      </AnimatePresence>
    </view.div>
  );
};
